<template>
  <v-dialog
    v-model="show"
    scrollable
    persistent
    width="500"
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-card-title>
        <strong>แก้ไขข้อมูล</strong>
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>fas fa-times</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text style="height: 540px">
        <div style="margin-top: 15px">
          <label>รูปภาพสินค้า</label>
          <el-upload
            class="upload"
            :on-success="handleSuccess"
            :file-list="file"
            :action="
              deliveryApiDomain +
              `/console/orders/` +
              order_reference +
              `/upload-custom`
            "
            :data="uploadData"
            :headers="uploadHeaders"
          >
            <v-btn block outlined color="primary">
              <i class="el-icon-upload"></i> อัพโหลดภาพสินค้า
            </v-btn>

            <!--
                    <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div>
                    -->
          </el-upload>
        </div>
        <v-divider class="my-5"></v-divider>
        <div style="margin-top: 15px">
          <label>หมายเลขการจัดส่งสินค้า</label>
          <el-input placeholder="ใส่หมายเลขจัดส่ง" v-model="form.custom_1">
          </el-input>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="white" depressed @click="close()">ปิด</v-btn>
        <v-btn color="primary" depressed @click="save()">บันทึก</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Service from "@/services";
import { monthList } from "@/utils/Constants";
import moment from "moment";
import { deliveryApiDomain } from "@/utils/Constants";

export default {
  name: "order-custom-field-dialog",
  props: {
    order_id: { default: null },
    custom_1: { default: null },
    showDialog: { default: false },
    order_reference: { default: null },
  },
  data() {
    return {
      deliveryApiDomain: deliveryApiDomain,
      loading: false,
      isPass: false,
      isError: false,
      form: {
        order_id: null,
        custom_1: "",
      },
      file: [],
      uploadHeaders: {
        Authorization: "",
      },
      uploadData: {
        type: "custom_4",
      },
    };
  },
  computed: {
    show: {
      get() {
        return this.showDialog;
      },
      set(value) {
        // If close dialog.
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
  created() {
    this.form.custom_1 = this.custom_1;

    let vuex = JSON.parse(localStorage.getItem("pro-halalize"));
    let accessToken = vuex.Auth.accessToken;
    this.uploadHeaders.Authorization = "Bearer " + accessToken;
  },
  methods: {
    handleSuccess(resp) {
      if (resp.success) {
        this.order.payment.payment_image_url_admin = resp.data.path;
        this.$notify({
          title: "สำเร็จ",
          message: "อัพโหลดรูปภาพสำเร็จ",
          type: "success",
        });
      }
    },
    save() {
      this.form.order_id = this.order_id;
      Service.Order.updateCustomField(this.form).then((res) => {
        this.$emit("close");
      });
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>